export default __webpack_public_path__ + "static/media/way2college.1efcacf4.png";